import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTASection() {
  return <section aria-label="Chiamata finale all'azione" className="bg-brand-dark text-white py-24 px-4 relative border-t border-brand-border" data-id="element-85">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-86">
        <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-6" data-id="element-87">
          <span className="text-xl" aria-hidden="true" data-id="element-88">
            🔬
          </span>{' '}
          FISICA PRONTA
        </div>
        <p className="text-xl md:text-2xl text-white/70 mb-4 italic" data-id="element-89">
          Il prossimo lunedì potresti arrivare stanco, dopo una domenica passata
          a pianificare.
        </p>
        <p className="text-2xl md:text-3xl font-heading font-bold text-brand-accent mb-16" data-id="element-90">
          Oppure potresti arrivare sorridente, sapendo che tutto il lavoro è già
          stato fatto per te.
        </p>
        <div className="mb-12" data-id="element-91">
          <CountdownTimer data-id="element-92" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16 max-w-2xl mx-auto" data-id="element-93">
          <div className="bg-brand-card p-6 rounded-2xl border border-brand-border flex flex-col items-center justify-between" data-id="element-94">
            <div className="font-bold text-white/60 mb-2 text-sm" data-id="element-95">
              ⚡ FISICA PRONTA
            </div>
            <div className="text-3xl font-heading font-bold text-white mb-4" data-id="element-96">
              €19
            </div>
            <button onClick={() => window.open('https://italia.edulabs.online/cart/43454242029686:1', '_blank')} className="w-full bg-brand-accent/10 border border-brand-accent/30 hover:bg-brand-accent/20 text-brand-accent py-4 rounded-2xl text-sm font-black transition-colors" data-id="element-97">
              → VOGLIO FISICA PRONTA
            </button>
          </div>
          <div className="bg-brand-card p-6 rounded-2xl border-2 border-brand-accent flex flex-col items-center justify-between transform md:scale-105 z-10 shadow-[0_0_30px_rgba(0,255,133,0.15)]" data-id="element-98">
            <div className="font-bold text-brand-accent mb-2 text-sm" data-id="element-99">
              🏆 COMBO SCIENZE ⭐
            </div>
            <div className="text-4xl font-heading font-bold text-brand-accent mb-4" data-id="element-100">
              €29
            </div>
            <button onClick={() => window.open('https://www.profepack.com/cart/48108607242496:1', '_blank')} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark py-4 rounded-2xl text-sm font-black transition-colors" data-id="element-101">
              → VOGLIO IL COMBO
            </button>
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-white/70 font-medium mb-16 text-sm" data-id="element-102">
          <span data-id="element-103">🔒 Pagamento sicuro</span>
          <span data-id="element-104">⚡ Accesso in 5 minuti</span>
          <span data-id="element-105">🛡️ Garanzia 7 giorni</span>
          <span data-id="element-106">💳 Carta | PayPal | Bonifico</span>
        </div>
        <div className="border-t border-brand-border pt-12 max-w-2xl mx-auto" data-id="element-107">
          <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-xs uppercase mb-4" data-id="element-108">
            <span aria-hidden="true" data-id="element-109">🔬</span> FISICA PRONTA
          </div>
          <p className="text-white/60 italic mb-2 text-sm" data-id="element-110">
            Il sistema "chiavi in mano" per docenti di scuola secondaria.
          </p>
          <p className="text-white/60 italic text-sm" data-id="element-111">
            Perché insegnare Fisica dovrebbe essere un piacere, non un lavoro
            extra casa.
          </p>
        </div>
      </div>
    </section>;
}